// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"b6","header":"b7","message":"b8","copyMessage":"b9","button":"b-"};